import React, { useEffect, useState } from 'react'
import { Parallax } from 'react-parallax'
import './css/secondpara.css'

const SecParallax = () => {
  const [awards, setAwards] = useState(0)
  const [cups, setCups] = useState(0)
  const [projects, setProjects] = useState(0)
  const [clients, setClients] = useState(0)
  useEffect(() => {
    const section = document.querySelector('#about')
    const lists = document.querySelectorAll('.about-li')
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          lists.forEach(i => {
            i.classList.add('animated-about')
          })
        }
      })
    })

    let animated = document.querySelectorAll('.animated-about')

    observer.observe(section)

    if (animated) {
      const awardsTimer = setInterval(() => {
        setAwards(prevAwards => {
          if (prevAwards >= 1) {
            clearInterval(awardsTimer)
          }
          return prevAwards + 1
        })
      }, 100)

      const cupsTimer = setInterval(() => {
        setCups(prevCups => {
          if (prevCups >= 500) {
            clearInterval(cupsTimer)
          }
          return prevCups + 1
        })
      }, 10)

      const projectsTimer = setInterval(() => {
        setProjects(prevProjects => {
          if (prevProjects >= 15) {
            clearInterval(projectsTimer)
          }
          return prevProjects + 1
        })
      }, 200)

      const clientsTimer = setInterval(() => {
        setClients(prevClients => {
          if (prevClients >= 38) {
            clearInterval(clientsTimer)
          }
          return prevClients + 1
        })
      }, 50)

      return () => {
        clearInterval(awardsTimer)
        clearInterval(cupsTimer)
        clearInterval(projectsTimer)
        clearInterval(clientsTimer)
      }
    }
  }, [])

  return (
    <Parallax className='paralax' bgImage='/paraImgs/pencil.jpg' strength={400}>
      {/* <div className='overlay'></div> */}

      <div id='about' className='secondpara'>
        <div style={{ marginTop: '4%' }} className='about-li title'>
          <p>HELLO THERE</p>
          <br />
          <div>LOKENDRA KUMAR</div>
          <hr />
        </div>
        <div className='about-li description'>
          As a web developer, I am passionate about creating high-quality
          websites and web applications that provide value to my clients and
          their customers. With years of experience, I have honed my skills in
          all aspects of web development, including front-end and back-end
          development, database design, and server management. <br /> <br />
          My technical expertise includes proficiency in <span>HTML</span>,{' '}
          <span>CSS</span>, <span>JavaScript</span>, <span>Node</span>, and
          various frameworks and content management systems such as{' '}
          <span>REACT</span>, <span>ANGULAR</span>, <span>Wordpress</span>. I am
          also committed to staying up-to-date with the latest technologies and
          best practices, ensuring that my clients receive the most cutting-edge
          solutions possible.
        </div>
        <div className='about-li records'>
          <div className='cads first'>
            <p>{awards}</p>
            <span>Awards Recieved</span>
          </div>
          <div className='cads second'>
            <p>{cups}</p>
            <span>Cups of Coffee</span>
          </div>
          <div className='cads third'>
            <p>{projects}</p>
            <span>Projects Completed</span>
          </div>
          <div className='cads fouth'>
            <p>{clients}</p>
            <span>Happy Clients</span>
          </div>
        </div>
      </div>
    </Parallax>
  )
}

export default SecParallax
